import { getPartnerBranding, getPartnerMenuLogoPaths } from './partnerBranding';

/**
 * Versão dos assets de marca em /public (logos, favicon, ícones PWA).
 * Incremente ao trocar qualquer PNG em public/ para forçar atualização nos navegadores.
 *
 * Ao alterar, atualize também:
 * - public/sw.js → BRAND_ASSET_VERSION
 * - public/index.html → ?v= nos ícones
 * - public/manifest.json → ?v= nos ícones
 */
export const BRAND_ASSET_VERSION = '20250603';

/** URL com query de cache bust (?v=...) — use em <img src>, CSS url(), notificações, etc. */
export function brandAsset(path: string): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  const sep = normalized.includes('?') ? '&' : '?';
  return `${normalized}${sep}v=${BRAND_ASSET_VERSION}`;
}

const partnerMenuLogos = getPartnerMenuLogoPaths();

export const BRAND_LOGO_MENU_EXPANDED = partnerMenuLogos
  ? brandAsset(partnerMenuLogos.expanded)
  : brandAsset('/13.png');
export const BRAND_LOGO_MENU_COLLAPSED = partnerMenuLogos
  ? brandAsset(partnerMenuLogos.collapsed)
  : brandAsset('/10.png');
export const BRAND_LOGO_LOGIN = brandAsset('/10.png');
export const BRAND_LOGO_PRIMARY = brandAsset('/principal-logo.png');
export const BRAND_LOGO_192 = brandAsset('/logo192.png');
export const BRAND_LOGO_512 = brandAsset('/logo512.png');

const partnerBranding = getPartnerBranding();
export const BRAND_FAVICON = partnerBranding
  ? brandAsset(partnerBranding.favicon)
  : brandAsset('/favicon.png');
